export default "__VITE_ASSET__3e0a3c41__"